import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { CheckboxContainer } from '../../Form/Checkbox';
import Label from '../Label';
const Wrapper = styled(Label) `
  display: inline-flex;
  height: 38px;
  align-items: center;
  position: relative;
  cursor: pointer;
  ${CheckboxContainer} {
    margin-right: 5px;
  }
`;
const Checkbox = ({ children, dataTestId }) => _jsx(Wrapper, { "data-testid": dataTestId, children: children });
export default Checkbox;
